<template>
  <unicom-cartao
    :marginBody="false"
    :estilo="{ 'margin-top': '16px' }"
    style="padding: 0"
  >
    <div slot="body">
      <StepRelatorio
        :tamanhoTela="$breakpoint.smAndDown ? 'mobile' : 'web'"
        :abas="abasData"
        @click="trocarAba"
      />
      <unicom-cartao style="padding: 0" :marginBody="false">
        <div slot="body" :style="estiloCartao">
          <transition :name="nomeTransicao" mode="out-in">
            <slot :indexAba="indexAba" />
          </transition>
        </div>
      </unicom-cartao>
    </div>
  </unicom-cartao>
</template>

<script>
import StepRelatorio from "./StepRelatorio/StepRelatorio";
export default {
  components: {
    StepRelatorio
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    abas: {
      type: Array,
      default: () => []
    },
    objetoEstiloCartao: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      indexAba: 0,
      proximo: true,
      abasData: []
    };
  },
  beforeMount() {
    this.carregarAbas();
  },
  methods: {
    trocarAba(index) {
      if (index === this.indexAba) return;

      this.$set(this.abasData[this.indexAba], "atual", false);
      this.$set(this.abasData[index], "atual", true);

      this.proximo = this.indexAba > index;

      this.indexAba = index;
      this.$emit("indexAtual", index);
    },
    carregarAbas() {
      this.abasData = this.abas.map(e => e);

      const indexAtual = this.abasData.findIndex(e => e.atual);
      if (indexAtual === -1) return;

      this.trocarAba(indexAtual);
    }
  },
  computed: {
    nomeTransicao() {
      return this.proximo ? "proximo" : "anterior";
    },
    estiloCartao() {
      if (this.objetoEstiloCartao === null) return {};
      return this.objetoEstiloCartao;
    }
  },
  watch: {
    index() {
      this.indexAba = this.index;
    },
    abas() {
      this.carregarAbas();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "StepperRelatorio";
</style>
